class FlowCoordinatePath {
  /*
   * This is a port of our PHP implementation of FlowCoordinatePath::compare.
   */
  static compare(path1: Array<number> | null, path2: Array<number> | null): number {
    const path1Normalized = path1 ?? []
    const path2Normalized = path2 ?? []
    const numParts1 = path1Normalized.length
    const numParts2 = path2Normalized.length
    const numParts = Math.min(numParts1, numParts2)
    for (let i = 0; i < numParts; i += 1) {
      const part1 = path1Normalized[i]
      const part2 = path2Normalized[i]
      if (part1 !== part2) {
        return part1 - part2
      }
    }
    return numParts1 - numParts2
  }
}

export default FlowCoordinatePath
